import { render, staticRenderFns } from "./editCoordinates.vue?vue&type=template&id=414d63fc&scoped=true&"
import script from "./editCoordinates.vue?vue&type=script&lang=js&"
export * from "./editCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./editCoordinates.vue?vue&type=style&index=0&id=414d63fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414d63fc",
  null
  
)

export default component.exports